module.exports = __webpack_public_path__ + "static/media/bass.92e2f0fc.jpg";